<template>
  <div class="page_box">
    <div class="head_box" :style="styleObj.head">
      <OneHead tit="数据可视化智能应用平台" style="height: 100%; width: 100%;" />
      <!-- <component v-for="(item, index) in layoutCompontent['head']" :key="index" :is="item.tag"></component> -->
    </div>
    <div class="main_content">
      <div class="left_box" :style="styleObj.left">
        <div
          v-for="(item, index) in layoutCompontent['left']"
          :key="index"
          :style="{ height: item.height, width: item.width, display: 'inline-block' }"
          @click="selCompontent('left', index)"
        >
          <component :is="item.tag" :itemData="item" :tit="item.tit" :color="item.color"></component>
        </div>
      </div>
      <div class="center_box" :style="styleObj.center">
        <div
          v-for="(item, index) in layoutCompontent['center']"
          :key="index"
          :style="{ height: item.height, width: item.width, display: 'inline-block' }"
          @click="selCompontent('center', index)"
        >
          <component :itemData="item" :is="item.tag"></component>
        </div>
      </div>
      <div class="right_box" :style="styleObj.right">
        <div
          v-for="(item, index) in layoutCompontent['right']"
          :key="index"
          :style="{ height: item.height, width: item.width, display: 'inline-block' }"
          @click="selCompontent('right', index)"
        >
          <component :itemData="item" :is="item.tag" :tit="item.tit" :color="item.color"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 自定义内容的组件
var exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null
    }
  },
  render: (h, data) => {
    const params = {
      row: data.props.row,
      index: data.props.index
    };
    if (data.props.column) params.column = data.props.column;
    return data.props.render(h, params);
  }
};
import Sortable from "sortablejs";
export default {
  components: {
    //自定义组件
    "ex-slot": exSlot,
    panel: () => import("./compontent/panel.vue"),
    OneHead: () => import("../../components/Theme/one/head.vue"),
    OneTit: () => import("../../components/Theme/one/tit.vue"),
    OneLineChart: () => import("../../components/Theme/one/dashboard/LineChart.vue"),
    OneBarChart: () => import("../../components/Theme/one/dashboard/BarChart.vue"),
    OneRingChart: () => import("../../components/Theme/one/dashboard/RingChart.vue"),
    OneWaterGlobeChart: () => import("../../components/Theme/one/dashboard/WaterGlobeChart.vue"),
    OneProChart: () => import("../../components/Theme/one/dashboard/proChart.vue"),
    ScrollList: () => import("../../components/Theme/one/ScrollList.vue"),
    OneCenterBox: () => import("../../components/Theme/one/center.vue")
  },
  data() {
    return {
      dataBoardInfo: {
        id: null,
        name: "",
        config: ""
      },
      show: false,
      infoData: {
        layout: "",
        sel: "",
        componentList: []
      },

      // 大屏可配置的 子组件
      components: [
        {
          label: "大屏1 - 模块标题",
          tag: "OneTit"
        },
        {
          label: "大屏1 - 线形图",
          tag: "OneLineChart"
        },
        {
          label: "大屏1 - 柱形图",
          tag: "OneBarChart"
        },
        {
          label: "大屏1 - 环形图",
          tag: "OneRingChart"
        },
        {
          label: "大屏1 - 水滴图",
          tag: "OneWaterGlobeChart"
        },
        {
          label: "大屏1 - 横向柱形图",
          tag: "OneProChart"
        },
        {
          label: "大屏1 - 滚动列表",
          tag: "ScrollList"
        },
        {
          label: "大屏1 - 中间组件",
          tag: "OneCenterBox"
        }
      ],

      // 布局样式
      styleObj: {
        head: {
          width: "100%",
          height: "84px",
          "background-img": "",
          "background-color": "",
          "text-align": "center"
        },
        left: {
          width: "25%",
          height: "100%"
          // "background-color": "pink"
        },
        center: {
          width: "50%",
          height: "100%"
          // "background-color": "red"
        },
        right: {
          width: "25%",
          height: "100%"
          // "background-color": "pink"
        }
      },
      layoutCompontent: {
        head: [],
        left: [],
        center: [],
        right: []
      },

      activeId: null,
      activeData: {},

      tableHeader: [
        {
          label: "组件标识",
          prop: "label"
        },
        {
          label: "组件名称",
          prop: "tag"
        }
      ]
    };
  },
  created() {
    if (this.$route.query.id) {
      this.dataBoardInfo.id = this.$route.query.id;
      this.getToolBiInfo();
    }
  },

  mounted() {},
  methods: {
    async getToolBiInfo() {
      const { data } = await this.$api.getToolBiInfo({
        id: this.dataBoardInfo.id
      });
      console.log("data", data);
      Object.keys(this.dataBoardInfo).forEach(key => {
        this.dataBoardInfo[key] = data[key];
      });
      let obj = JSON.parse(this.dataBoardInfo.config);
      if (obj) this.layoutCompontent = obj;

      // obj["left"].forEach(el => {
      //   if (el.viewId) {
      //     this.getChartData(el);
      //   }
      // });

      this.activeData = this.layoutCompontent["left"][0];
    },
    async getChartData(el) {
      const { data } = await this.$api.getChartData({
        id: el.viewId
      });
    },
    onSave() {
      sessionStorage.setItem("layoutCompontent", JSON.stringify(this.layoutCompontent));
      this.dataBoardInfo.config = JSON.stringify(this.layoutCompontent);
      if (this.dataBoardInfo.id) {
        this.$emit("onUpdate", this.dataBoardInfo);
      } else {
        this.$emit("onAdd", this.dataBoardInfo);
      }
    },
    diaClose() {
      this.$emit("diaClose");
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".drow_table  .el-table__body-wrapper tbody");
      // console.log("tbody", tbody);
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          console.log("newIndex, oldIndex", newIndex, oldIndex);
          let currRow = _this.infoData.componentList.splice(oldIndex, 1)[0];
          console.log("currRow", currRow);
          _this.infoData.componentList.splice(newIndex, 0, currRow);
          // console.log("_this.infoData.componentList", _this.infoData.componentList);
          _this.onSort(_this.infoData.componentList);
        }
      });
    },
    setLayout() {
      this.infoData.componentList = this.layoutCompontent[this.infoData.layout];
    },
    addItem() {
      let obj = {};
      switch (this.infoData.sel) {
        case "OneTit":
          obj = {
            tag: this.infoData.sel,
            label: "",
            width: "100%",
            height: "45px",
            tit: ""
          };
          break;
        default:
          obj = {
            tag: this.infoData.sel,
            label: "",
            width: "100%",
            height: "30%"
          };
          break;
      }
      this.infoData.componentList.push(obj);
    },
    deleteItem(i) {
      this.infoData.componentList.splice(i, 1);
    },

    selCompontent(position, index) {
      console.log("88888888888");
      this.activeData = this.layoutCompontent[position][index];
      console.log("activeData", this.activeData);
    }
  }
};
</script>

<style lang="scss" scoped>
.page_box {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/theme/one/bg.png");
  // background-image: url("../../assets/theme/one/center.png");
  background-repeat: no-repeat;
  background-size: 100%;
  // display: flex;
  // flex-direction: column;

  .head_box {
    width: 100%;
  }

  .main_content {
    width: 100%;
    // height: calc(100% - 84px);
    height: calc(100% - 100px);
    // height: 100%;
    // flex: 1;
  }

  .left_box,
  .center_box,
  .right_box {
    display: inline-block;
    vertical-align: top;
  }
}

.operation_box {
  position: fixed;
  right: 0;
  top: 0;
  width: 350px;
  height: 200px;
  z-index: 100;
  // background-color: pink;
  text-align: center;
  background-color: #fff;

  .close_btn {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

.btn_box {
  position: fixed;
  right: 0;
  top: 30%;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 3px;
  z-index: 100;
  text-align: center;
  background-color: #fff;
}

.input_box {
  display: inline-block;
}

.sel_box {
  border: 2px solid aquamarine;
  box-sizing: border-box;
}
.goBack {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 80px;
  z-index: 100;
}
</style>
